import React from "react";
import { css } from "react-emotion";
import * as styles from "../newStyles.styles";
import Footer from "../Footer";
import Header from "../Header";
import LoginSignup from "../Authentication/LoginSignup";
import CalendyForm from "../MarketingLandingPage/CalendyForm";

const body = css`
  * {
    *,
    *:before,
    *:after {
      box-sizing: inherit;
    }
  }
  height: 100%;
  margin: 0;
  padding-top: 0.1px;
`;
// classes
const wrapper = css`
  width: 100%;
  margin: 0 auto;
  float: none;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

function HowItWorks({ history }) {
  return (
    <div className={body}>
      <div className={wrapper}>
        <Header history={history} />
        <main
          style={{
            width: "100%",
            minHeight: "100vh",
            backgroundColor: "rgb(255, 255, 255)",
            flex: "1 0 auto",
            textAlign: "center",
          }}
        >
          <div
            className={styles.row}
            style={{ marginBottom: "0px", justifyContent: "center" }}
          >
            {" "}
            <styles.H2
              style={{
                textAlign: "center",
                marginBottom: "0px",
                marginTop: "60px",
              }}
            >
              How It <span className={styles.styledUnderline}>Works</span>
            </styles.H2>
          </div>
          <div
            className={styles.row}
            style={{
              marginBottom: "0px",
              padding: "30px 10px",
            }}
          >
            {/************************************************************************************************
             *************************************************************************************************
             * Add Screens Row
             * 3 column Row that includes the number as an img src from s3, the text and finally the img src
             * from s3.
             *************************************************************************************************
             ************************************************************************************************/}
            <div className={styles.maxWidthWrapper}>
              <div className={styles.col + " " + styles.col_ss}>
                <img
                  src="https://mobile360-assets.s3.us-east-2.amazonaws.com/landing/1.png"
                  className={styles.step}
                  alt="step-1"
                ></img>
              </div>
              <div className={styles.col + " " + styles.col_xs}>
                <styles.ColoredH5>
                  Build Your App &amp; Website
                </styles.ColoredH5>
                <styles.P>
                  We’ve made the simplest no-code app and website builder
                  possible. No coding. No logic blocks. No difficult design
                  decisions.
                  <br /> <br />
                  Build your app and website in just 30 minutes. It’s that
                  simple.
                </styles.P>
              </div>
              <div className={styles.col + " " + styles.col1_4_pic}>
                <img
                  src="https://mobile360-assets.s3.us-east-2.amazonaws.com/landing/app_builder_overview.png"
                  className={styles.addScreens}
                  alt="add-screens"
                ></img>
              </div>
            </div>
          </div>
          <div
            className={styles.row}
            style={{ marginBottom: "0px", padding: "30px 10px" }}
          >
            {/************************************************************************************************
             *************************************************************************************************
             * Publish Row
             * 3 column Row that includes the number as an img src from s3, the text and finally the img src
             * from s3. The offwite style above refers to the light green blue background.
             *************************************************************************************************
             ************************************************************************************************/}
            <div className={styles.maxWidthWrapper}>
              <div className={styles.col + " " + styles.col_ss}>
                <img
                  src="https://mobile360-assets.s3.us-east-2.amazonaws.com/landing/2.png"
                  className={styles.step}
                  alt="step-2"
                ></img>
              </div>
              <div className={styles.col + " " + styles.col_xs}>
                <styles.ColoredH5>
                  Launch Your App and Website to the Mobile360 Marketplace
                </styles.ColoredH5>
                <styles.P>
                  All apps created on Mobile360 get hosted in the core Mobile360
                  app, known as the Mobile360 marketplace.
                  <br /> <br />
                  The marketplace app allows us to manage the nuances,
                  maintenance 🛠, design 🎨, and expensive costs 💰 of having a
                  mobile app, while you leverage all the benefits of having one.
                </styles.P>
              </div>
              <div className={styles.col + " " + styles.col1_4_pic}>
                <img
                  src="https://mobile360-assets.s3.us-east-2.amazonaws.com/landing/marketplace_overview.png"
                  className={styles.addScreens}
                  alt="publish-app"
                ></img>
              </div>
            </div>
          </div>
          <div
            className={styles.row}
            style={{ marginBottom: "0px", padding: "30px 10px" }}
          >
            {/************************************************************************************************
             *************************************************************************************************
             * Business Grow Row
             * 3 column Row that includes the number as an img src from s3, the text and finally the img src
             * from s3.
             *************************************************************************************************
             ************************************************************************************************/}
            <div className={styles.maxWidthWrapper}>
              <div className={styles.col + " " + styles.col_ss}>
                <img
                  src="https://mobile360-assets.s3.us-east-2.amazonaws.com/landing/3.png"
                  className={styles.step}
                  alt="step-3"
                ></img>
              </div>
              <div className={styles.col + " " + styles.col_xs}>
                <styles.ColoredH5>
                  Engage Customers and Grow 🚀
                </styles.ColoredH5>
                <styles.P>
                  Blast your app download link and QR code to your customers. In
                  one click, we take them directly to your app or website within
                  Mobile360.
                  <br />
                  <br />
                  Reengage them with push notifications, special offers,
                  exclusive content, and more.
                </styles.P>
              </div>
              <div className={styles.col + " " + styles.col1_4_pic}>
                <img
                  src="https://mobile360-assets.s3.us-east-2.amazonaws.com/download_link_code.png"
                  // src="https://mobile360-assets.s3.us-east-2.amazonaws.com/landing/marketplace_download_overview.png"
                  className={styles.addScreens}
                  alt="watch-it-grow"
                ></img>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                margin: "30px",
                width: "100%",
              }}
            >
              <LoginSignup
                buttonText="Get Started Now"
                fontWeight="bold"
                fontSize="20px"
              />
            </div>
          </div>
          <div className={styles.row}>
            {/************************************************************************************************
             *************************************************************************************************
             * Schedule a Demo Row
             * This row is for Calendy Demo scheduling
             *************************************************************************************************
             ************************************************************************************************/}
            <div className={styles.maxWidthWrapper}>
              <div className={styles.col + " " + styles.col1}>
                <styles.H2
                  style={{
                    textAlign: "center",
                    width: "100%",
                    marginBottom: "30px",
                  }}
                >
                  Schedule a Free 30 Minute{" "}
                  <span className={styles.styledUnderline}>Demo</span>
                </styles.H2>

                <br></br>
                <CalendyForm />
              </div>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </div>
  );
}

export default HowItWorks;
